<template lang="pug">
	
	div#componenteBaseMapSelect(v-if="selectedBaseMap")
		div(@click="showOptions = !showOptions", :class="{active : showOptions}")
			i.fa.fa-map-o.mr-1
			span.mr-2 {{selectedBaseMap.name}}
			i.fa.fa-angle-up

		transition(name="el-zoom-in-bottom")

			div#options(v-show="showOptions")
				div
					a.dropdown-title Mapas de fundo
					a.dropdown-item(v-for='baseMap in baseMaps', @click="changeBaseMap(baseMap)") {{ baseMap.name }}
		
</template>

<script>

import Config from '@/config.js';

import { mapMutations } from 'vuex';

export default {
	name: 'BaseMapSelect',

	data () {
		return {
			baseMaps: Config.baseMaps,
			showOptions: false,
			selectedBaseMap: null
		};
	},

	methods: {
		
		changeBaseMap (baseMap) {

			this.showOptions = false;

			if (this.selectedBaseMap === baseMap) return;

			this.selectedBaseMap = baseMap;
			this.setBaseMap(baseMap);
			this.$bus.$emit('mapa.changeBaseMap', baseMap);
		},

		/**
		 * Injeta os métodos do Vuex que serão utilizados pela classe
		 */
		...mapMutations([
			'setBaseMap'
		])
	},

	mounted () {
		
		this.selectedBaseMap = _.find(this.baseMaps, (baseMap) => {
			return baseMap.default;
		});
	}
};

</script>

<style lang="scss" scoped>

@import "../styles/mixins.scss";
@import '../styles/variaveis';

#componenteBaseMapSelect {
	
	color: $base-map-select-color;
	background-color: $base-map-select-bg;
	height: 100%;
	cursor: pointer;

	#options {
		
		border-radius: $default-border-radius;
		@include box-shadow(0px, 3px, 6px, rgba(0,0,0,0.16)); //TODO: Extrair
		position: absolute;
		bottom: $bottom-bar-height + 1;
		background: $base-map-select-options-bg;
		left: 0;
		
		.dropdown-title {
			display: block;
			width: 100%;
			padding: 0.25rem 1.5rem;
			font-weight: 600;
			font-size: $base-map-select-title-font-size;
			border-bottom: 1px solid $base-map-select-title-border-color;
			cursor: default;
		}

		.dropdown-item:hover {
			background-color: $base-map-select-option-item-hover-bg;
			color: $base-map-select-hover-color;
		}

		.dropdown-item:active {
			background-color: $base-map-select-option-item-active-bg;
			color: $base-map-select-hover-color;
		}

		color: $base-map-select-options-color;
	}

	&:hover, .active {
		color: $base-map-select-active-color;
	}
}

</style>



// WEBPACK FOOTER //
// BaseMapSelect.vue?1cb115bb